import React, { useState, useEffect } from 'react'
import { useDispatch, useStore } from 'react-redux'
import CheckboxComponent from '../../CommonComponents/CheckboxComponent'
import Select from 'react-select/creatable'
import { toast } from '../../CommonComponents/ToastComponent/toast'
import { getCustomerNames } from '../../../redux/actions/vendor'
import LoaderComponent from '../../CommonComponents/LoaderComponent'
import { getPartnerNames } from '../../../redux/actions/partner'
import { getAllRemainingListSuppliersIds } from '../../../redux/actions/caller'

const FilterComponent = ({ columns, filterValues, onChangeFilters, onCancel, onApplyFilter, vendorsInCalls = null, listId, tab, isSpendGreaterValue }) => {
    const store = useStore().getState()
    const dispatch = useDispatch()
    const {
        partner: { partnerNames },
        user: { callerUsers }
    } = store
    const [filterCheckValues, setFilterCheckValues] = useState({})
    const [customerNames, setCustomerNames] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [suppliers, setSuppliers] = useState([])
    const [isSpendGreater, setIsSpendGreater] = useState(true);

    useEffect(async () => {
        setIsLoading(true)
        if (columns?.findIndex(x => x.name === "showAllAssigned") !== -1 && !vendorsInCalls) {
            dispatch(getAllRemainingListSuppliersIds({ listId, checkedKeys: [], isGetNotInCalls: true, isGetAllSuppliers: true })).then((listSuppliers) => {
                setSuppliers(listSuppliers || [])
            })
        } else {
            setSuppliers(vendorsInCalls || [])
        }
        await dispatch(getPartnerNames()).then().catch(() => setIsLoading(false))
        if (tab !== 'partnerSubmissions') {
            await dispatch(getCustomerNames()).then((customers) => {
                setCustomerNames(customers)
            }).catch(() => setIsLoading(false))
        }
        setIsLoading(false)
        let tmpCheckValues = {}
        columns.map(column => {
            if (column.name === 'dateSubmitted' || column.name === 'createdAt') {
                tmpCheckValues[column.name] = (filterValues?.hasOwnProperty('start_date') || filterValues?.hasOwnProperty('end_date')) ? true : false
            } else {
                tmpCheckValues[column.name] = filterValues?.hasOwnProperty(column.name) ? true : false
            }
        })
        setFilterCheckValues(tmpCheckValues)
        setIsSpendGreater(isSpendGreaterValue)
    }, [])

    const handleCheckboxChange = (value, colName) => {
        setFilterCheckValues({
            ...filterCheckValues,
            [colName]: value
        })
        if (!value) {
            if (colName === 'dateSubmitted' || colName === 'createdAt') {
                onChangeFilters('', 'date')
            } else {
                onChangeFilters('', colName)
            }
        }
    }

    const handleApplyClick = () => {
        if (Object.keys(filterValues).length === 0) {
            toast.show({
                title: 'Danger',
                description: 'Please select and add at least one filter!'
            })
            return
        }
        onApplyFilter()
    }

    const handleCancelClick = () => {
        let tmpCheckValues = {}
        columns.map(column => {
            tmpCheckValues[column.name] = false
        })
        setFilterCheckValues(tmpCheckValues)
        onCancel()
    }

    const formatCreateLabel = (inputValue) => {
        return inputValue;
    };

    const toggleOperator = () => {
        setIsSpendGreater(prev => !prev)
        onChangeFilters(!isSpendGreater, 'spendComparisionChange')
    };

    return (
        <div className={`filter-component p-2 border p-4 rounded${isLoading ? ' loading' : ''}`}>
            {isLoading && <LoaderComponent />}
            <div className='row align-items-center'>
                {columns && columns.map((column) => {
                    return (
                        <>
                            <div className={`${column.name !== 'showAllAssigned' ? 'col-6' : 'col-6'} d-flex flex-column`}>
                                <div className='d-flex'>
                                    <h4 className='mb-0 text-black'>{column.label}</h4>
                                    {column.name !== 'showAllAssigned' && (
                                        <div className={`me-5 ms-auto`}>
                                            <CheckboxComponent
                                                checked={filterCheckValues?.[column.name]}
                                                onChange={(checked) => { handleCheckboxChange(checked, column.name) }}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                            {<div className='col-6 d-flex flex-column '>
                                {column.name === 'dateSubmitted' || column.name === 'createdAt' ?
                                    <div className='d-flex align-items-center gap-3 border rounded pt-3 pb-3 p-2'>
                                        <input type="date" id="start" name="date-start" className='border-0' style={{ width: "110px", padding: "0px 1px 0px 1px" }}
                                            value={filterValues?.start_date || ''} disabled={!filterCheckValues?.[column.name]} required
                                            onChange={(event) => { onChangeFilters(event.target.value, 'start_date') }}
                                        />
                                        <span className='h4 mb-0'>To</span>
                                        <input type="date" id="end" name="date-end" className='border-0' style={{ width: "110px", padding: "0px 1px 0px 1px" }}
                                            value={filterValues?.end_date || ''} disabled={!filterCheckValues?.[column.name]} required
                                            onChange={(event) => { onChangeFilters(event.target.value, 'end_date') }}
                                        />
                                    </div>
                                    :
                                    column.name === 'showAllAssigned' ?
                                        <div className={`ms-auto`}>
                                            <CheckboxComponent
                                                checked={filterValues?.[column.name]}
                                                onChange={(checked) => { onChangeFilters(checked, column.name) }}
                                            />
                                        </div>
                                        :
                                        column.name === 'spend' ? (
                                            <div className="d-flex align-items-center gap-3 rounded pt-3 pb-3 px-2">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-secondary"
                                                    onClick={toggleOperator}
                                                    disabled={!filterCheckValues?.[column.name]}
                                                >
                                                    {isSpendGreater ? '≥' : '≤'}
                                                </button>
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Enter value"
                                                    value={filterValues?.[column.name] || ''}
                                                    onChange={(event) => { onChangeFilters(event.target.value, column.name) }}
                                                    disabled={!filterCheckValues?.[column.name]}
                                                />
                                            </div>

                                        ) :
                                            <Select
                                                isMulti={column?.isMulti || false}
                                                closeMenuOnSelect={column?.isMulti ? false : true}
                                                placeholder=''
                                                value={column.name === 'callerAssigned' ?
                                                    (filterValues?.[column.name] ? filterValues?.[column.name] : null)
                                                    : column.name === 'partnerId' && tab === 'partnerSubmissions' ? {
                                                        label: partnerNames?.find(data => data?.id === filterValues?.[column.name])?.partnerName,
                                                        value: filterValues?.[column.name]
                                                    } : column.name === 'currentStatus' && tab === 'partnerSubmissions' ? (
                                                        filterValues?.[column.name] ? filterValues?.[column.name] : null
                                                    )
                                                        : {
                                                            label: filterValues?.[column.name],
                                                            value: filterValues?.[column.name]
                                                        }}
                                                options={
                                                    column.name == 'partnerName' || column.name == 'partnerId' ?
                                                        partnerNames.length ? partnerNames?.map((option) => (
                                                            {
                                                                label: option?.partnerName,
                                                                value: tab === 'partnerSubmissions' ? option?.id : option?.partnerName
                                                            }
                                                        )) : [] :
                                                        column.name == 'customerName' ?
                                                            customerNames.length ? customerNames?.map((option) => (
                                                                {
                                                                    label: option?.companyName,
                                                                    value: option?.companyName
                                                                }
                                                            )) : [] :
                                                            column.name === 'callerAssigned' ?
                                                                callerUsers?.length ? callerUsers.map((user) => (
                                                                    {
                                                                        label: user?.firstname + (user?.lastname ? ' ' + user?.lastname : ''),
                                                                        value: user?.id
                                                                    }
                                                                )) : []
                                                                :
                                                                column.name === 'suppliername' ?
                                                                    suppliers?.length ? suppliers.map((option) => (
                                                                        {
                                                                            label: option?.suppliername,
                                                                            value: option?.suppliername
                                                                        }
                                                                    )) : []
                                                                    :
                                                                    column?.options.map((option) => (
                                                                        {
                                                                            label: option,
                                                                            value: option
                                                                        }
                                                                    ))
                                                }
                                                formatCreateLabel={formatCreateLabel}
                                                className="select-searchoption text-black h4 mb-0"
                                                onChange={(item) => { onChangeFilters(column?.isMulti ? item : column.name === 'callerAssigned' ? item : item?.value, column.name) }}
                                                isDisabled={!filterCheckValues?.[column.name]}
                                            />
                                }
                            </div>}
                        </>
                    )
                })}
            </div>
            <div className='filter-footer d-flex flex-wrap justify-content-center gap-3 mt-5'>
                <button className='bg-gray text-white rounded p-3 ps-5 pe-5 h4 mb-0' onClick={() => { handleCancelClick() }}>Cancel</button>
                <button className='bg-green text-white rounded p-3 ps-5 pe-5 h4 mb-0' onClick={() => { handleApplyClick() }}>Apply Filter</button>
            </div>
        </div>
    )
}

export default FilterComponent